import LeadSource from "./lead-source.js";
import CampaignSource from "./campaign-source.js";

// Publishes a small, stable attribution API on window so the shipped lead-source /
// campaign-source resolvers can be invoked outside the module system. This is the
// documented public boundary consumed by:
//   - the Playwright suite Hypertherm.E2E.Playwright/Tests/LeadSourceAttributionTests.cs
//   - the manual matrix in Docs/test-plans/lead-source-attribution-test-plan.md
//
// The actual resolution logic lives in LeadSource / CampaignSource; this is only a
// thin adapter over them so there is a single source of truth for the rules.
function resolveLeadSource() {
    // LeadSource.getLeadSourceValues() always returns an array with exactly one
    // { ls, lsd } pair; surface that pair directly.
    const [pair] = new LeadSource().getLeadSourceValues();
    return pair;
}

function resolveCampaignSource() {
    return new CampaignSource().getCampaignSourceValue();
}

// Never clobber an existing runtime (e.g. if two entry bundles are ever loaded on
// the same page) so the contract stays stable and idempotent.
window.htAttribution = window.htAttribution || {
    resolveLeadSource,
    resolveCampaignSource
};
